/*
 * ELTANE — referral invite popup
 *
 * Shows snippets/eltane-referral-popup.liquid's markup only when the
 * current URL carries Shopify's ?discount={code} param (i.e. the visitor
 * just landed via a friend's /discount/{code} referral link) and only once
 * per browser, ever — repeat or unrelated visits stay quiet.
 */
(function () {
  'use strict';

  var SHOWN_KEY = 'eltane_referral_popup_shown';

  function hasReferralParam() {
    try {
      return !!new URLSearchParams(window.location.search).get('discount');
    } catch (e) {
      return false;
    }
  }

  function alreadyShown() {
    try {
      return localStorage.getItem(SHOWN_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markShown() {
    try {
      localStorage.setItem(SHOWN_KEY, '1');
    } catch (e) {}
  }

  document.addEventListener('DOMContentLoaded', function () {
    var popup = document.getElementById('EltaneReferralPopup');
    if (!popup || !hasReferralParam() || alreadyShown()) return;

    markShown();
    popup.hidden = false;
    document.body.classList.add('eltane-referral-popup-open');

    function dismiss() {
      popup.hidden = true;
      document.body.classList.remove('eltane-referral-popup-open');
      document.removeEventListener('keydown', onKeydown);
    }

    function onKeydown(event) {
      if (event.key === 'Escape') dismiss();
    }

    var dismissTriggers = popup.querySelectorAll('[data-eltane-referral-popup-dismiss]');
    for (var i = 0; i < dismissTriggers.length; i++) {
      dismissTriggers[i].addEventListener('click', dismiss);
    }
    document.addEventListener('keydown', onKeydown);
  });
})();
